import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject,Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService
{
    private readonly breakpointObserver = inject(BreakpointObserver);

    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor()
    {
        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void
    {

        this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ]).subscribe(result => {
            for (const query of Object.keys(result.breakpoints)) {
                if (result.breakpoints[query]) {
                    let activeMediaQuery = query;
                    if (this.activeMediaQuery !== activeMediaQuery) {
                        this.activeMediaQuery = activeMediaQuery;
                        this.onMediaChange.next(activeMediaQuery);
                    }
                }
            }
        });
    }
}
